(function () {
  'use strict';

  var state = { result: null };
  var byId = function (id) { return document.getElementById(id); };
  var text = function (id, value) { var node = byId(id); if (node) node.textContent = value == null ? '—' : value; };
  var number = function (value, digits) {
    if (value===null||value===undefined||value===''||!Number.isFinite(Number(value))) return '—';
    return Number(value).toLocaleString('en-IN', { minimumFractionDigits: digits || 0, maximumFractionDigits: digits || 0 });
  };
  var inputValue = function (id) { var node = byId(id); return node ? node.value : ''; };
  var pctLoss = function (previous, current) { return previous > 0 ? ((previous - current) / previous) * 100 : null; };

  function renderSnapshotFromResult(result) {
    text('ic-ree-label', (result.energy.tier === 1 ? 'Measured' : 'Estimated') + ' Resting Energy Expenditure (REE)');
    text('ic-ree-val', number(result.energy.ree, 0));
    text('ic-ree-sub', result.energy.method);
    text('ic-tdee-label', result.patient.context === 'icu' ? 'Energy before ICU phase adjustment' : 'Estimated daily energy before clinical adjustment');
    text('ic-tdee-val', number(result.energy.tdee, 0));
    text('ic-final-val', result.blocked ? 'Withheld' : (result.energy.display || number(result.energy.target, 0)));
    text('ic-final-note', result.blocked ? result.status.copy : result.energy.targetPhase);
    text('ic-bmi-val', number(result.weights.bmi, 1));
    text('ic-bmi-cat', result.weights.bmiCategory);
    text('ic-quality-status-value', result.status.title);
    text('ic-quality-status-reason', result.status.copy);
    text('ic-formula-method', result.energy.method);
    text('ic-formula-expression', result.energy.formula);
    text('ic-formula-inputs', result.energy.inputs);
    text('ic-formula-assumptions', result.energy.assumptions);
    text('ic-formula-target-phase', result.energy.targetPhase);
    text('ic-formula-protein-basis', result.protein.basis + ' · ' + result.protein.range + ' g/kg/day');
    text('ic-protein-range', result.protein.range + ' g/kg/day');
    text('ic-protein-min', 'Min: ' + number(result.protein.min, 1) + ' g/day');
    text('ic-protein-rec', 'Max: ' + number(result.protein.max, 1) + ' g/day');
    text('ic-protein-src', result.protein.source);
    text('ic-protein-basis', 'Basis: ' + result.protein.basis);
  }

  function addWeightCard(container, label, value, source, use, formula) {
    var card = document.createElement('article');
    card.className = 'mep-weight-card';
    var heading = document.createElement('span');
    var result = document.createElement('strong');
    var sourceNode = document.createElement('p');
    var useNode = document.createElement('small');
    heading.textContent = label;
    result.textContent = value;
    sourceNode.textContent = source;
    useNode.textContent = use;
    card.appendChild(heading);
    card.appendChild(result);
    if (formula) {
      var formulaNode = document.createElement('code');
      formulaNode.textContent = formula;
      card.appendChild(formulaNode);
    }
    card.appendChild(sourceNode);
    card.appendChild(useNode);
    container.appendChild(card);
  }

  function renderWeightTable(result) {
    var body = byId('mep-weight-rows');
    if (!body) return;
    body.innerHTML = '';
    var w = result.weights;
    var reasons = result.selectedWeightReasons || { energy: 'Drives the energy estimate', protein: 'Drives the protein prescription' };
    addWeightCard(body, 'Current actual weight', number(w.actual, 1) + ' kg', w.sourceLabel, 'Baseline scale weight');
    if (w.usual > 0) addWeightCard(body, 'Usual body weight', number(w.usual, 1) + ' kg', 'Clinician-entered', 'Weight trend reference');
    if (w.usual > 0) addWeightCard(body, 'Change from usual weight', number(Math.abs(w.usual - w.actual), 1) + ' kg ' + (w.actual <= w.usual ? 'loss' : 'gain') + ' · ' + number(Math.abs(pctLoss(w.usual, w.actual)), 1) + '%', 'Compared with usual weight', 'Malnutrition screening context', '(previous − current) ÷ previous × 100');
    addWeightCard(body, 'Height', number(result.patient.height, 1) + ' cm', 'Measured / reported', 'BMI and reference weights');
    addWeightCard(body, 'BMI', number(w.bmi, 1) + ' kg/m²', w.bmiCategory, 'Screening context', number(w.actual, 1) + ' ÷ (' + number(result.patient.height / 100, 2) + '²)');
    if (w.ibw > 0) addWeightCard(body, 'Ideal body weight', number(w.ibw, 1) + ' kg', w.ibwSource === 'Local clinician-entered override' ? w.ibwSource : 'Devine formula', 'Adult reference / selected protocol', 'Base weight + 2.3 × inches over 5 ft');
    if (w.percentIBW > 0) addWeightCard(body, 'Percentage of IBW', number(w.percentIBW, 1) + '%', 'Actual ÷ IBW × 100', 'Adult weight interpretation', number(w.actual, 1) + ' ÷ ' + number(w.ibw, 1) + ' × 100');
    if (w.adjusted > 0) addWeightCard(body, 'Adjusted body weight', number(w.adjusted, 1) + ' kg', 'Correction factor ' + number(w.adjustmentFactor, 2), 'Adult obesity protocol use', number(w.ibw, 1) + ' + ' + number(w.adjustmentFactor, 2) + ' × (' + number(w.actual, 1) + ' − ' + number(w.ibw, 1) + ')');
    if (w.dry > 0) addWeightCard(body, 'Dry / euvolemic weight', number(w.dry, 1) + ' kg', 'Clinician-entered; never estimated', 'Fluid overload / ascites / dialysis');
    if (w.postDialysis > 0) addWeightCard(body, 'Post-dialysis weight', number(w.postDialysis, 1) + ' kg', 'Clinician-entered', 'Dialysis and fluid interpretation');
    if (w.lbm > 0) addWeightCard(body, 'Lean body mass', number(w.lbm, 1) + ' kg', w.lbmSource, 'Body composition reference', w.bodyFatPct > 0 ? number(w.actual, 1) + ' × (1 − ' + number(w.bodyFatPct, 1) + '%)' : 'Measured or Boer estimate');
    if (w.bodyFatPct > 0) addWeightCard(body, 'Body-fat percentage', number(w.bodyFatPct, 1) + '%', 'Clinician-entered', 'Body composition reference');
    if (w.fatMass >= 0) addWeightCard(body, 'Fat mass', number(w.fatMass, 1) + ' kg', 'Actual weight − lean body mass', 'Optional reference', number(w.actual, 1) + ' − ' + number(w.lbm, 1));
    text('mep-energy-weight', result.energy.weightBasis);
    text('mep-protein-weight', result.protein.basis);
    text('mep-energy-basis-summary', result.energy.weightBasis + ' — ' + reasons.energy);
    text('mep-protein-basis-summary', number(result.protein.weight, 1) + ' kg — ' + reasons.protein);
  }

  function trendCard(label, value) {
    var card = document.createElement('div');
    var labelNode = document.createElement('span');
    var valueNode = document.createElement('strong');
    labelNode.textContent = label;
    valueNode.textContent = value;
    card.appendChild(labelNode);
    card.appendChild(valueNode);
    return card;
  }

  function renderTrend(result) {
    var grid = byId('mep-trend-grid');
    var flag = byId('mep-trend-flag');
    if (!grid || !flag) return;
    grid.innerHTML = '';
    var w = result.weights;
    grid.appendChild(trendCard('Current weight', number(w.actual, 1) + ' kg'));
    grid.appendChild(trendCard('Usual weight', w.usual > 0 ? number(w.usual, 1) + ' kg' : 'Not entered'));
    ['1m', '3m', '6m'].forEach(function (period) {
      var previous = w.history[period];
      var change = previous > 0 ? previous - w.actual : 0;
      var changeLabel = change >= 0 ? ' loss' : ' gain';
      grid.appendChild(trendCard(period.replace('m', '-month change'), previous > 0 ? number(Math.abs(change), 1) + ' kg' + changeLabel + ' · ' + number(Math.abs(pctLoss(previous, w.actual)), 1) + '%' : 'Not entered'));
    });
    var concerning = [];
    if (w.usual > 0 && pctLoss(w.usual, w.actual) >= 5) concerning.push(number(pctLoss(w.usual, w.actual), 1) + '% from usual weight');
    if (w.history['1m'] > 0 && pctLoss(w.history['1m'], w.actual) >= 5) concerning.push(number(pctLoss(w.history['1m'], w.actual), 1) + '% in 1 month');
    if (w.history['3m'] > 0 && pctLoss(w.history['3m'], w.actual) >= 7.5) concerning.push(number(pctLoss(w.history['3m'], w.actual), 1) + '% in 3 months');
    if (w.history['6m'] > 0 && pctLoss(w.history['6m'], w.actual) >= 10) concerning.push(number(pctLoss(w.history['6m'], w.actual), 1) + '% in 6 months');
    flag.hidden = concerning.length === 0;
    flag.textContent = concerning.length ? 'Significant unintentional weight loss requires malnutrition-risk review: ' + concerning.join('; ') + '.' : '';
  }

  function renderAdjustments(result) {
    var wrap = byId('mep-adjustments');
    if (!wrap) return;
    wrap.innerHTML = '';
    var modifiers = result.modifiers || { applied: [], ignored: [] };
    (modifiers.applied || []).forEach(function (message) {
      var item = document.createElement('div');
      item.dataset.level = 'applied';
      item.textContent = 'Applied — ' + message;
      wrap.appendChild(item);
    });
    (modifiers.ignored || []).forEach(function (message) {
      var item = document.createElement('div');
      item.dataset.level = 'ignored';
      item.textContent = 'Not applied — ' + message;
      wrap.appendChild(item);
    });
    var relevant = result.flags.filter(function (flag) { return flag.type !== 'success'; });
    if (!relevant.length) relevant = [{ type: 'info', msg: 'No additional clinical adjustment was selected. Reassess when the condition or route changes.' }];
    relevant.slice(0, 12).forEach(function (flag) {
      var item = document.createElement('div');
      item.dataset.level = flag.type;
      item.textContent = flag.msg;
      wrap.appendChild(item);
    });
  }

  function renderCalculationSteps(result) {
    var wrap = byId('mep-calculation-steps');
    if (!wrap) return;
    wrap.innerHTML = '';
    (result.calculationSteps || []).forEach(function (step, index) {
      var row = document.createElement('div');
      var numberNode = document.createElement('span');
      var content = document.createElement('div');
      var label = document.createElement('strong');
      var value = document.createElement('p');
      row.className = 'mep-calculation-step';
      numberNode.textContent = String(index + 1);
      label.textContent = step.label;
      value.textContent = step.value;
      content.appendChild(label);
      content.appendChild(value);
      row.appendChild(numberNode);
      row.appendChild(content);
      wrap.appendChild(row);
    });
  }

  function ledgerRow(container, label, value) {
    if (!container || value == null || value === '') return;
    var row = document.createElement('div');
    var key = document.createElement('span');
    var detail = document.createElement('code');
    key.textContent = label;
    detail.textContent = value;
    row.appendChild(key);
    row.appendChild(detail);
    container.appendChild(row);
  }

  function renderCompleteCalculations(result) {
    var audit = result.calculationAudit || {};
    var protein = byId('mep-protein-calculation');
    if (protein) {
      protein.innerHTML = '';
      var p = audit.protein || result.protein.calculation || {};
      ledgerRow(protein, 'Protocol / rate', (p.protocol || result.protein.source) + ' · ' + (p.rateRange || result.protein.range + ' g/kg/day'));
      ledgerRow(protein, 'Selected dosing weight', p.selectedWeightLabel || result.protein.basis);
      ledgerRow(protein, 'Minimum', p.minimum);
      ledgerRow(protein, 'Maximum', p.maximum);
      ledgerRow(protein, 'Midpoint used for delivery comparison', p.midpoint);
      ledgerRow(protein, 'Progression note', p.progression);
    }

    var weights = byId('mep-weight-calculations');
    if (weights) {
      weights.innerHTML = '';
      var wc = result.weightCalculations || {};
      [['BMI', wc.bmi], ['Ideal body weight', wc.idealWeight], ['Adjusted body weight', wc.adjustedWeight], ['Percentage of IBW', wc.percentIBW], ['Lean body mass', wc.leanBodyMass], ['Fat mass', wc.fatMass]].forEach(function (entry) {
        if (!entry[1]) return;
        ledgerRow(weights, entry[0] + ' formula', entry[1].formula);
        ledgerRow(weights, entry[0] + ' substitution', entry[1].substitution || (number(entry[1].value, 2)));
      });
      var history = wc.weightHistory || {};
      [['Change from usual weight', history.usual], ['1-month change', history['1m']], ['3-month change', history['3m']], ['6-month change', history['6m']]].forEach(function (entry) {
        if (entry[1]) ledgerRow(weights, entry[0], entry[1].substitution);
      });
      ledgerRow(weights, 'Selected energy basis reason', (result.selectedWeightReasons || {}).energy);
      ledgerRow(weights, 'Selected protein basis reason', (result.selectedWeightReasons || {}).protein);
    }

    var validity = byId('mep-validity-checks');
    if (validity) {
      validity.innerHTML = '';
      (audit.validity || []).forEach(function (check) {
        var row = document.createElement('div');
        row.dataset.status = String(check.status || 'Recorded').toLowerCase();
        var name = document.createElement('strong');
        var evidence = document.createElement('span');
        var status = document.createElement('b');
        var effect = document.createElement('small');
        name.textContent = check.label;
        evidence.textContent = check.evidence;
        status.textContent = check.status;
        effect.textContent = check.effect;
        row.appendChild(name); row.appendChild(evidence); row.appendChild(status); row.appendChild(effect);
        validity.appendChild(row);
      });
    }

    var delivery = byId('mep-delivery-calculation');
    if (delivery) {
      delivery.innerHTML = '';
      var d = audit.delivery || {};
      (d.components || []).forEach(function (component) {
        ledgerRow(delivery, component.source, number(component.energy, 0) + ' kcal/day + ' + number(component.protein, 1) + ' g protein/day');
      });
      ledgerRow(delivery, 'Energy sum', d.energySum || 'No delivery values entered');
      ledgerRow(delivery, 'Protein sum', d.proteinSum || 'No delivery values entered');
      ledgerRow(delivery, 'Energy achievement', d.energyAchievement);
      ledgerRow(delivery, 'Protein achievement', d.proteinAchievement);
    }
  }

  function renderProtocols(result) {
    var wrap = byId('mep-protocol-list');
    if (!wrap) return;
    wrap.innerHTML = '';
    Object.keys(result.protocols).forEach(function (key) {
      var row = document.createElement('div');
      var dt = document.createElement('dt');
      var dd = document.createElement('dd');
      dt.textContent = key;
      dd.textContent = result.protocols[key];
      row.appendChild(dt);
      row.appendChild(dd);
      wrap.appendChild(row);
    });
  }

  function renderDelivery(result) {
    var d = result.delivery;
    text('mep-energy-delivered', d.energyKnown ? number(d.energy, 0) + ' kcal' : 'Not assessed');
    text('mep-protein-delivered', d.proteinKnown ? number(d.protein, 1) + ' g' : 'Not assessed');
    text('mep-energy-achievement', d.energyKnown ? (d.usable ? number(d.energyPct, 0) + (result.energy.operator === '<' ? '% of exclusive ceiling, not target attainment' : '% of current target') : 'Target comparison withheld') : 'Energy delivery not assessed');
    text('mep-protein-achievement', d.proteinKnown ? number(d.proteinPct, 0) + '% of midpoint target' : 'Protein delivery not assessed');
    text('mep-shortfall', d.entered ? number(d.energyShortfall, 0) + ' kcal · ' + number(d.proteinShortfall, 1) + ' g protein' : '—');
    text('mep-delivery-note', d.note);
  }

  function renderSecondary(result) {
    var equations = byId('mep-equation-comparison');
    var macros = byId('mep-macro-summary');
    if (equations) {
      equations.innerHTML = '';
      result.comparisons.forEach(function (row) {
        var line = document.createElement('div');
        line.className = 'mep-secondary-row';
        var name = document.createElement('span');
        var value = document.createElement('strong');
        name.textContent = row.name;
        value.textContent = number(row.ree, 0) + ' kcal (' + row.delta + ')';
        line.appendChild(name); line.appendChild(value); equations.appendChild(line);
      });
    }
    if (macros) {
      macros.innerHTML = '';
      [['Protein', result.macros.protein], ['Fat', result.macros.fat], ['Carbohydrate', result.macros.carbohydrate]].forEach(function (item) {
        var line = document.createElement('div');
        line.className = 'mep-secondary-row';
        var name = document.createElement('span');
        var value = document.createElement('strong');
        name.textContent = item[0]; value.textContent = item[1];
        line.appendChild(name); line.appendChild(value); macros.appendChild(line);
      });
    }
  }

  function buildNote(result) {
    var w = result.weights;
    var d = result.delivery;
    var audit = result.calculationAudit || {};
    var pcalc = audit.protein || result.protein.calculation || {};
    var wc = result.weightCalculations || {};
    var validityLines = (audit.validity || []).map(function (check) { return '- ' + check.label + ': ' + check.evidence + ' [' + check.status + '] — ' + check.effect; });
    var weightCalculationLines = [];
    [['BMI', wc.bmi], ['Ideal body weight', wc.idealWeight], ['Adjusted body weight', wc.adjustedWeight], ['Percentage IBW', wc.percentIBW], ['Lean body mass', wc.leanBodyMass], ['Fat mass', wc.fatMass]].forEach(function (entry) {
      if (entry[1]) weightCalculationLines.push('- ' + entry[0] + ': ' + entry[1].formula + ' | ' + (entry[1].substitution || number(entry[1].value, 2)));
    });
    var history = wc.weightHistory || {};
    [['Usual', history.usual], ['1 month', history['1m']], ['3 months', history['3m']], ['6 months', history['6m']]].forEach(function (entry) {
      if (entry[1]) weightCalculationLines.push('- Weight change ' + entry[0] + ': ' + entry[1].substitution);
    });
    var deliveryAudit = audit.delivery || {};
    return [
      'NUTRITION ASSESSMENT',
      '',
      'Date/time: ' + result.generatedAt,
      'Patient ID: ' + (result.patient.id || 'Not entered'),
      'Dietitian initials: ' + (result.patient.dietitianInitials || 'Not entered'),
      'Review status: ' + (result.patient.reviewStatus || 'Draft — requires clinician review'),
      'Clinical setting: ' + result.patient.contextLabel,
      '',
      'Anthropometry:',
      'Current weight: ' + number(w.actual, 1) + ' kg (' + w.sourceLabel + ')',
      'Usual weight: ' + (w.usual > 0 ? number(w.usual, 1) + ' kg' : 'Not entered'),
      'Weight loss: ' + (w.usual > 0 ? number(w.usual - w.actual, 1) + ' kg, ' + number(pctLoss(w.usual, w.actual), 1) + '%' : 'Not calculated'),
      'BMI: ' + number(w.bmi, 1) + ' kg/m² (' + w.bmiCategory + ')',
      'Selected energy basis: ' + result.energy.weightBasis,
      'Selected protein weight: ' + result.protein.basis,
      'Energy basis reason: ' + ((result.selectedWeightReasons || {}).energy || 'Not recorded'),
      'Protein basis reason: ' + ((result.selectedWeightReasons || {}).protein || 'Not recorded'),
      '',
      'ANTHROPOMETRY CALCULATIONS',
      weightCalculationLines.join('\n') || '- No derived anthropometry available',
      '',
      'Metabolic method: ' + result.energy.method,
      'Formula: ' + result.energy.formula,
      'Substitution: ' + result.energy.inputs,
      'Worked REE calculation: ' + ((audit.energy || {}).arithmetic || result.energy.workedCalculation),
      'Target calculation:',
      ((audit.energy || {}).targetSteps || []).map(function (step, index) { return (index + 1) + '. ' + step; }).join('\n') || result.energy.workedCalculation,
      'Rounding: ' + ((audit.energy || {}).rounding || 'Nearest whole kcal for display'),
      'Measurement validity: ' + result.status.title,
      'Limitations: ' + result.energy.assumptions,
      '',
      'VALIDITY CHECKS',
      validityLines.join('\n') || '- Predictive estimate; no gas-measurement validity checks',
      '',
      (result.energy.tier === 1 ? 'Measured' : 'Estimated') + ' REE: ' + number(result.energy.ree, 0) + ' kcal/day',
      'Current energy target: ' + (result.blocked ? 'Withheld pending valid measurement' : (result.energy.display || number(result.energy.target, 0)) + ' kcal/day'),
      'Protein target: ' + number(result.protein.min, 1) + '–' + number(result.protein.max, 1) + ' g/day (' + result.protein.range + ' g/kg/day)',
      'Protein weight basis: ' + result.protein.basis,
      'Protein minimum calculation: ' + (pcalc.minimum || 'Not available'),
      'Protein maximum calculation: ' + (pcalc.maximum || 'Not available'),
      'Protein midpoint calculation: ' + (pcalc.midpoint || 'Not available'),
      '',
      'Clinical adjustments:',
      'Applied modifiers: ' + (((result.modifiers || {}).applied || []).join(' | ') || 'None'),
      'Modifiers not applied: ' + (((result.modifiers || {}).ignored || []).join(' | ') || 'None'),
      result.flags.filter(function (f) { return f.type !== 'success'; }).slice(0, 8).map(function (f) { return '- ' + f.msg; }).join('\n') || '- No additional adjustment selected.',
      '',
      'Current delivery:',
      d.energyKnown ? 'Energy delivered: ' + number(d.energy, 0) + ' kcal/day (' + (d.usable ? number(d.energyPct, 0) + (result.energy.operator === '<' ? '% of exclusive ceiling' : '% of target') : 'target comparison withheld') + ')' : 'Energy delivered: Not assessed',
      d.proteinKnown ? 'Protein delivered: ' + number(d.protein, 1) + ' g/day (' + number(d.proteinPct, 0) + '% of target)' : 'Protein delivered: Not assessed',
      'Energy delivery arithmetic: ' + (deliveryAudit.energySum || 'Not calculated'),
      'Protein delivery arithmetic: ' + (deliveryAudit.proteinSum || 'Not calculated'),
      'Energy achievement arithmetic: ' + (deliveryAudit.energyAchievement || 'Not calculated'),
      'Protein achievement arithmetic: ' + (deliveryAudit.proteinAchievement || 'Not calculated'),
      '',
      'Plan: Advance, maintain, or reassess based on tolerance, intake, fluid balance, laboratory data, refeeding risk, and clinical condition.',
      '',
      'Protocols: ' + Object.keys(result.protocols).map(function (key) { return key + ': ' + result.protocols[key]; }).join(' | '),
      'Calculator: DietXP Metabolic Energy Profiler, algorithm ' + ((result.algorithm || {}).version || 'not recorded'),
      'Guideline review date: ' + ((result.algorithm || {}).guidelineReviewDate || 'not recorded'),
      'References: ' + Object.keys(result.references || {}).map(function (key) { return key + ': ' + result.references[key]; }).join(' | '),
      'Report generated locally. Not a prescription without clinician review.',
      '',
      'Clinician sign-off: ____________________   Date/time: ____________________'
    ].join('\n');
  }

  function render(result) {
    if (!result) return;
    state.result = result;
    renderSnapshotFromResult(result);
    var report = byId('mep-full-report');
    if (report) report.hidden = false;
    text('mep-report-time', result.generatedAt);
    text('mep-report-algorithm', 'DietXP algorithm ' + ((result.algorithm || {}).version || '—'));
    text('mep-report-patient-id', result.patient.id || 'Not entered');
    text('mep-report-dietitian', result.patient.dietitianInitials || 'Not entered');
    text('mep-report-review-status', result.patient.reviewStatus || 'Draft — requires clinician review');
    text('mep-report-guideline-date', (result.algorithm || {}).guidelineReviewDate || '—');
    var status = byId('mep-status-banner');
    if (status) status.dataset.status = result.status.type;
    text('mep-status-title', result.status.title);
    text('mep-status-copy', result.status.copy);
    text('mep-ree-label', result.energy.tier === 1 ? 'Measured REE' : 'Estimated REE');
    text('mep-ree', number(result.energy.ree, 0));
    text('mep-ree-method', result.energy.method);
    text('mep-energy-target', result.blocked ? 'Withheld' : (result.energy.display || number(result.energy.target, 0)));
    text('mep-energy-phase', result.energy.targetPhase);
    text('mep-expected-target', result.blocked ? 'Reassess' : number(result.energy.expectedTarget, 0));
    var expectedTarget = document.querySelector('.mep-expected-target');
    if (expectedTarget) expectedTarget.hidden = result.patient.context !== 'icu';
    text('mep-protein-target', number(result.protein.min, 1) + '–' + number(result.protein.max, 1));
    text('mep-protein-basis-report', result.protein.range + ' g/kg/day using ' + result.protein.basis);
    text('mep-method', result.energy.method);
    text('mep-validity', result.status.title);
    text('mep-formula', result.energy.formula);
    text('mep-substitution', result.energy.inputs);
    text('mep-worked-calculation', result.energy.workedCalculation);
    text('mep-assumptions', result.energy.assumptions);
    renderCalculationSteps(result);
    renderCompleteCalculations(result);
    renderWeightTable(result);
    renderTrend(result);
    renderAdjustments(result);
    renderProtocols(result);
    renderDelivery(result);
    renderSecondary(result);
    var note = buildNote(result);
    var noteArea = byId('mep-dietitian-note');
    if (noteArea) noteArea.value = note;
  }

  function copyNote() {
    if (!state.result) return;
    var note = buildNote(state.result);
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(note);
    else {
      var area = byId('mep-dietitian-note');
      if (area) { area.select(); document.execCommand('copy'); }
    }
    var button = byId('mep-copy-note');
    if (button) { var old = button.textContent; button.textContent = 'Copied'; setTimeout(function () { button.textContent = old; }, 1600); }
  }

  function downloadReport() {
    if (!state.result) return;
    var blob = new Blob([buildNote(state.result)], { type: 'text/plain;charset=utf-8' });
    var url = URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = url;
    link.download = 'DietXP_Clinical_Metabolic_Report_' + new Date().toISOString().slice(0, 10) + '.txt';
    document.body.appendChild(link); link.click(); link.remove(); URL.revokeObjectURL(url);
  }

  function bind() {
    window.DietXP = window.DietXP || {};
    window.DietXP.MEP = window.DietXP.MEP || {};
    window.DietXP.MEP.report = { buildNote: buildNote, copyNote: copyNote, downloadReport: downloadReport, render: render };
    var copy = byId('mep-copy-note'); if (copy) copy.addEventListener('click', copyNote);
    var snapshotCopy = byId('mep-snapshot-copy'); if (snapshotCopy) snapshotCopy.addEventListener('click', copyNote);
    var download = byId('mep-download-report'); if (download) download.addEventListener('click', downloadReport);
    var print = byId('mep-print-report'); if (print) print.addEventListener('click', function () { window.print(); });
    document.addEventListener('dietxp:mep-result', function (event) { render(event.detail); });
    if (window.DietXP && window.DietXP.MEP && window.DietXP.MEP.currentResult) render(window.DietXP.MEP.currentResult);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
})();
